import { Flex, Spin, Tabs, type TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { Companies } from '@modules/profile/user/companies/ui/companies';
import { PersonalDetails } from '@modules/profile/user/personal-details/ui/personal-details';
import { useGetMeUserMeGetQuery } from '@shared/api';
import { PageHeader } from '@shared/ui/page-header';
import { FetchingErrorState } from '@shared/ui/fetching-error-state/fetching-error-state';

import styles from './profile.module.scss';

export const Profile = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'profile.user' });
  const { data: user, isLoading, isError, refetch } = useGetMeUserMeGetQuery();

  const tabs: TabsProps['items'] = [
    {
      key: 'personal',
      label: t('tabs.personal'),
      children: user ? <PersonalDetails user={user} /> : null,
    },
    {
      key: 'companies',
      label: t('tabs.companies'),
      children: <Companies user={user} />,
    },
  ];

  return (
    <Flex vertical className={styles.root} align="center">
      <PageHeader title={t('pageTitle')} />

      <Flex flex={1} justify="center" align="center" className={styles.frame}>
        {isLoading && (
          <Flex flex={1} align="center" justify="center">
            <Spin />
          </Flex>
        )}

        {!isLoading && isError && <FetchingErrorState refetch={refetch} />}

        {!isLoading && !isError && <Tabs items={tabs} className={styles.tabs} />}
      </Flex>
    </Flex>
  );
};
